import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../redux/userRedux";
import profileImg from "../assets/images/user.jpg";
import logoImg from "../assets/images/labzy-logo.webp";

function Topbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const users = useSelector((state) => state.user);
  const { _id, labName, mobileNumber, labEmail } = users?.currentUser || {};

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggleSideBar = () => {
    document.body.classList.toggle("toggle-sidebar");
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const initials = labName
    ? labName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
    : "LB";

  return (
    <header className="topbar" id="header">
      {/* ── Left: logo + toggle ── */}
      <div className="topbar-left">
        <a href="/" className="topbar-logo" aria-label="Home">
          <img src={logoImg} alt="LabBridge logo" className="topbar-logo-img" />
          <span className="topbar-logo-text">LabBridge</span>
        </a>

        <button
          className="topbar-menu-btn"
          onClick={handleToggleSideBar}
          aria-label="Toggle sidebar"
        >
          <i className="bi bi-list" />
        </button>
      </div>

      {/* ── Right: actions ── */}
      <div className="topbar-right">
        {/* Profile dropdown */}
        <div className="topbar-profile" ref={dropdownRef}>
          <button
            className="topbar-profile-btn"
            onClick={() => setDropdownOpen((o) => !o)}
            aria-expanded={dropdownOpen}
            aria-haspopup="true"
          >
            <div className="topbar-avatar">{initials}</div>
            <div className="topbar-profile-info">
              <span className="topbar-profile-name">{"Labzy"}</span>
              <span className="topbar-profile-role">Admin</span>
            </div>
            <i className={`bi bi-chevron-${dropdownOpen ? "up" : "down"} topbar-chevron`} />
          </button>

          {dropdownOpen && (
            <div className="topbar-dropdown">
              <div className="topbar-dropdown-header">
                <div className="topbar-avatar topbar-avatar-lg">{initials}</div>
                <div>
                  <p className="topbar-dh-name">{labName}</p>
                  <p className="topbar-dh-email">{labEmail || mobileNumber}</p>
                </div>
              </div>

              <div className="topbar-dropdown-divider" />

              <Link
                to={`/profile/${_id}`}
                className="topbar-dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                <span className="item-icon-wrap">
                  <i className="bi bi-person-circle" />
                </span>
                <span>My Profile</span>
              </Link>

              <div className="topbar-dropdown-divider" />

              <button className="topbar-dropdown-item topbar-logout" onClick={handleLogout}>
                <span className="item-icon-wrap">
                  <i className="bi bi-box-arrow-right" />
                </span>
                <span>Sign Out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Topbar;
